<template>
  <div class="dqyxfx-warp">
    <resize-container :tabShow="tabShow">
      <div class="left-content" v-show="tabShow" slot="left">
        <tab-tree :data="viewTreeData" @tabTreeDefault="tabTreeDefault" @tabTreeClick="tabTreeClick" @changeCompany="changeCompany"></tab-tree>
      </div>
      <div class="right-content">
        <btn-show @show="tabShow = !tabShow" content="左边树"></btn-show>
        <div class="dn-content-bg box1 zt">
          <time-search ref="timeSearch" :control="{ data: timeData }" @timeControlChange="timeControlChange" @timeControlClick="TimeControlClick">
          </time-search>
        </div>
        <div class="tab-pane">
          <div class="tap-echarts dn-content-bg">
            <div class="echarts">
              <echarts :echartsData="echartsData" :direction="'top'" type="rate"></echarts>
            </div>
          </div>
          <div class="tables table-content dn-content-bg">
            <nk-table id="table" :data="tableData" :noDataTitle="'该时间段暂无数据'" :columns="columns" :border="false" :rowselect="true">
            </nk-table>
          </div>
        </div>
      </div>
    </resize-container>
  </div>
</template>
<script>
import { findDataByParam } from "@/utils/index.js";
import * as utils from "@/utils/index.js";
import echarts from "./pages/echarts.vue";
import TimeSearch from "@/components/common/TimeSearch.vue";
import TabTree from "@/components/common/TabTree.vue";
import handleData from "@/utils/handleData.js";
import dateTool from "@/utils/dateTool";
import NkTable from "@/components/common/NkTable";
import BtnShow from "@/components/common/BtnShow.vue";
import ResizeContainer from "@/components/common/resizeContainer.vue";
import { isNull, isUndefined } from "util";
let allTimeData = [
  {
    type: "day",
    label: "日",
  },
  {
    type: "month",
    label: "月",
  },
  {
    type: "year",
    label: "年",
  },
];
export default {
  components: {
    TimeSearch,
    TabTree,
    echarts,
    NkTable,
    BtnShow,
    ResizeContainer,
  },
  data () {
    return {
      tabShow: true,
      viewTreeData: [],
      timeData: allTimeData,
      alarnclass: "alarnclass",
      columns: [],
      tableData: [],
      chartData: [],
      measurea: [],
      selectedDate: {},
      workEle: 980,
      noWorkEle: 990,
      workHb: +150,
      workHbl: +8,
      noWorkHb: -150,
      noWorkHbl: -8,
      timeOne: true,
      timeTwo: false,
      valueOne: "",
      valueTwo: "",
      echartsData: {},
      form: {},
    };
  },
  created () { },
  activated () { },
  methods: {
    changeCompany (companyId) {
      let vm = this;
      vm.$api.frontEndPageCustomParam.getMyFrontEndPageCustomParam(companyId, "/nygl/shfxps", null)
        .then((res) => {
          if (res) {
            const viewTreeData = findDataByParam("viewTree", true, res.data);
            vm.viewTreeData = viewTreeData;
            res.data.forEach((item) => {
              if (item.param == "pointInfo") {
                this.form = JSON.parse(item.value);
              }
            });
          }
        });
    },
    /* 树加载 */
    tabTreeDefault (e) {
      this.selectNodes = e;
      let time = new Date();
      let startTime = dateTool.format(time, "yyyy-MM-dd ") + "00:00:00";
      time.setDate(time.getDate() + 1);
      let endTime = dateTool.format(time, "yyyy-MM-dd") + " 00:00:00";
      this.selectedDate = {
        dataType: "1",
        dateType: "day",
        startTime: startTime,
        endTime: endTime,
      };
      this.TimeControlClick(this.selectedDate);
    },
    /* 树点击 */
    tabTreeClick (e) {
      this.tableData1 = [];
      this.goodfont = false;
      this.goodfont1 = false;
      this.selectNodes = e;
      this.TimeControlClick(this.selectedDate);
    },
    timeControlChange () { },
    /* 修改能源类型 */
    changeEnergy (val) {
      this.form = this.energyData.find((item) => {
        //遍历list的数据
        return item.type === val; //筛选出匹配数据
      });
    },
    /* 查询 */
    TimeControlClick (e) {
      this.selectedDate = e;
      this.getData();
    },
    async getData () {
      let vm = this;
      let pointCode = vm.form.pointCode;
      let pointNumber = vm.form.pointNumber;
      let startTime = vm.selectedDate.startTime;
      let time = new Date(vm.selectedDate.startTime);
      let endTime = vm.selectedDate.endTime;
      let dateType = vm.selectedDate.dateType;
      let lastStart = null;
      let useTime = null; //本期用量时间
      let useTimeLast = null; //环期用量时间

      if (dateType == "day") {
        time.setDate(time.getDate() - 1);
        lastStart = dateTool.format(time, "yyyy-MM-dd") + " 00:00:00";
        useTime = dateTool.format(new Date(startTime), "yyyy年-MM月-dd日");
        useTimeLast = dateTool.format(new Date(endTime), "yyyy年-MM月-dd日");
      } else if (dateType == "month") {
        time.setMonth(new Date(time).getMonth() - 1);
        lastStart = dateTool.format(new Date(time), "yyyy-MM-") + "01 00:00:00";
        useTime = dateTool.format(new Date(startTime), "yyyy年-MM月");
        useTimeLast = dateTool.format(new Date(endTime), "yyyy年-MM月");
      } else {
        time.setFullYear(new Date(time).getFullYear() - 1);
        lastStart = dateTool.format(new Date(time), "yyyy-") + "01/01 00:00:00";
        useTime = dateTool.format(new Date(startTime), "yyyy年");
        useTimeLast = dateTool.format(new Date(endTime), "yyyy年");
      }
      let lastEnd = startTime;
      let res = await vm.$api.tmp.getLossAnalysis(
        vm.selectNodes.id,
        pointCode,
        pointNumber,
        startTime,
        endTime,
        dateType
      ); //本期
      let resTwo = await vm.$api.tmp.getLossAnalysis(
        vm.selectNodes.id,
        pointCode,
        pointNumber,
        lastStart,
        lastEnd,
        dateType
      ); //环期
      let startTimeDate = null;
      let lastStartDate = null;
      if (vm.selectedDate.dateType == "day") {
        startTimeDate = startTime.substring(0, 11);
        lastStartDate = lastStart.substring(0, 11);
      } else if (vm.selectedDate.dateType == "month") {
        startTimeDate = startTime.substring(0, 7);
        lastStartDate = lastStart.substring(0, 7);
      } else {
        startTimeDate = startTime.substring(0, 4);
        lastStartDate = lastStart.substring(0, 4);
      }
      let obj = {
        legend: [startTimeDate, lastStartDate],
        xData: res.data.xData,
        unit: vm.form.unit,
        series: [
          {
            data: res.data.yData,
            type: "line",
            name: startTimeDate,
          },
          {
            data: resTwo.data.yData,
            type: "line",
            name: lastStartDate,
          },
        ],
      };
      this.echartsData = obj;
      let columns = [
        {
          prop: "name",
          label: "测量点名称",
          show: true,
          align: "left",
        },
        {
          prop: "time",
          label: "用量时间",
          show: true,
          align: "center",
        },
        {
          prop: "maxValue",
          label: "最大能源损耗趋势比值(%)",
          show: true,
          align: "center",
        },
        {
          prop: "maxTime",
          label: "最大能源损耗趋势比值发生时间",
          show: true,
          align: "center",
        },
        {
          prop: "minValue",
          label: "最小能源损耗趋势比值(%)",
          show: true,
          align: "center",
        },
        {
          prop: "minTime",
          label: "最小能源损耗趋势比值发生时间",
          show: true,
          align: "center",
        },
      ];
      this.columns = columns;
      let tableData = [{}, {}];
      res.data.maxValue =
        res.data.maxValue != "-" ? res.data.maxValue : res.data.maxValue;
      res.data.minValue =
        res.data.minValue != "-" ? res.data.minValue : res.data.minValue;
      resTwo.data.maxValue =
        resTwo.data.maxValue != "-"
          ? resTwo.data.maxValue
          : resTwo.data.maxValue;
      resTwo.data.minValue =
        resTwo.data.minValue != "-"
          ? resTwo.data.minValue
          : resTwo.data.minValue;
      tableData[0] = res.data;
      tableData[0].name = vm.selectNodes.measureName;
      tableData[0].time = startTime;
      tableData[1] = resTwo.data;
      tableData[1].name = vm.selectNodes.measureName;
      tableData[1].time = lastStart;
      this.tableData = tableData;
    },
  },
};
</script>
<style  scoped lang="scss">
.dqyxfx-warp {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 14px;
  box-sizing: border-box;
  overflow: hidden;
}
.left-content {
  height: 100%;
  min-width: 200px;
  margin-right: 14px;
}
.right-content {
  height: 100%;
  position: relative;
  overflow: auto;
  display: flex;
  flex-flow: column;
}
.box1 {
  padding: 5px;
  box-sizing: border-box;
  color: #2e3842;
  margin-bottom: 14px;
}
.tab-pane {
  width: 100%;
  height: calc(100% - 84px);
  border-radius: 4px;
  .tap-echarts {
    height: 70%;
    margin-bottom: 14px;
    .tab-top {
      height: 45px;
      line-height: 45px;
      padding: 0 14px;
      box-sizing: border-box;
      text-align: left;
      color: #fff;
      font-size: 20px;
      border-radius: 4px 4px 0px 0px;
    }
    .echarts {
      height: 100%;
      width: 100%;
    }
  }
  .tables {
    height: calc(30% - 14px);
    width: 100%;
  }
}
.flex {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.flex1 {
  flex: 2;
  display: flex;
  justify-content: center;
  align-items: center;
}
.big {
  color: #bc635e;
}
.small {
  color: #7fad7d;
}
</style>